/**
 * **Sihot**
 *
 * @exports bs_258
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};

  /**
     * @memberOf module:bs_258
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {

      const aux = window.location.pathname.match(ctx.urlRe);
      if (aux && aux.length > 1 && ctx.langs.test(aux[1])) {
        resolve(aux[1]);
        return;
      }

      resolve('en');
    });
  };

  /**
     * @memberOf module:bs_258
     * @see {@link prestart}
     *
     * @param {object} ctx - The context object.
     */
  engine.boot = function boot() {
    const rootDiv = document.querySelector('#sihotWeb_root');

    if (rootDiv && !thn.sihotBeObserver) {
      thn.sihotBeObserver = thn.debounce(function thnSihotBeObserver() {
        if (!document.querySelector('.k-loading-mask')) {
          thn.pageCheck();
          if (thn.widgets.price.isSet()) {
            // Reset the PW for proper loading when returning to R&R
            thn.widgets.price.reset();
          }
        }
      }, 400);

      thn.observeDom(rootDiv, thn.sihotBeObserver, {
        childList: true,
        subtree: true,
      });

      thn.shutdown(function () {
        thn.stopObserveDom(rootDiv, thn.sihotBeObserver);
        delete thn.sihotBeObserver;
      });
    }
  };

  /**
     * @memberOf module:bs_258
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};
    const $ = window.jQuery;

    if (!$) { return widgetData; }

    // Dates
    // from inputs
    const checkin = ($('input[data-bind="value: arrivalDeparture.arrival"]').val() || '').match(/([0-9]*)\D+([0-9]*)\D+([0-9]*)/);
    const checkout = ($('input[data-bind="value: arrivalDeparture.departure"]').val() || '').match(/([0-9]*)\D+([0-9]*)\D+([0-9]*)/);
    // Depends on the language the date format is MM/DD/YYYY or DD/MM/YYYY
    const specialLanguage = thn.data.language.match(/en|de|sv/);
    if (checkin && checkout) {
      widgetData.dateBegin = `${(`20${checkin[3]}`).slice(-4)}/${(`0${checkin[specialLanguage ? 1 : 2]}`).slice(-2)}/${(`0${checkin[specialLanguage ? 2 : 1]}`).slice(-2)}`;
      widgetData.dateEnd = `${(`20${checkout[3]}`).slice(-4)}/${(`0${checkout[specialLanguage ? 1 : 2]}`).slice(-2)}/${(`0${checkout[specialLanguage ? 2 : 1]}`).slice(-2)}`;
    } else { // From url when inputs don't have values
      widgetData.dateBegin = thn.parseUrlParameter('ARR') && thn.parseUrlParameter('ARR').replace(/-/g, '/');
      widgetData.dateEnd = thn.parseUrlParameter('DEP') && thn.parseUrlParameter('DEP').replace(/-/g, '/');
    }

    // Guests, Adults & Children
    widgetData.adults = parseInt($('div[data-bind="value: numberOfAdults"]').val(), 10) || 2;
    widgetData.children = parseInt($('div[data-bind="value: numberOfChildren"]').val(), 10) || 0;
    widgetData.guests = widgetData.adults + widgetData.children;

    // Prices & Currency || No Rooms
    const prices = $('.s_roomPanelPrice, .s_ratePanelPrice').map((idx, price) => thn.parseNumber($(price).text().trim()));
    if (prices.length) {
      widgetData.price = (Math.min(...prices) / thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd)).toFixed(2);
      widgetData.currency = 'CHF';
      widgetData.set = true;
    } else {
      widgetData.noRooms = true;
    }

    return widgetData;
  };

  /**
     * @memberOf module:bs_258
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};
    const $ = window.jQuery;
    const dl = window.dataLayer;

    if (!$) { return widgetData; }

    const $bookingDataDetails = $('.s_conf_section > .col-12:eq(7)');
    const $bookingDataPrice = $('.s_conf_section > .col-12:eq(10)');

    // Noo booking ID in datalayer
    if (dl) {
      widgetData.dateBegin = thn.dataLayerHelper.get('checkIn').replace(/-/g, '/');
      widgetData.dateEnd = thn.dataLayerHelper.get('checkOut').replace(/-/g, '/');
      widgetData.promocode = thn.dataLayerHelper.get('promoCode');
      widgetData.price = thn.dataLayerHelper.get('totalPrice') || thn.dataLayerHelper.get('transactionTotal');
      widgetData.currency = thn.dataLayerHelper.get('currency') || thn.dataLayerHelper.get('transactionCurrency');
    }

    // DOM Tables
    if ($bookingDataDetails.length && $bookingDataPrice.length) {
      widgetData.bookingId = $bookingDataDetails.find('.row:eq(8) > .col-6:eq(1)').text()
                // Prefer DOM booking ID, transactionId isn't the same format but it's better than nothing.
                || (dl && thn.dataLayerHelper.get('transactionId'));

      // Fallback values if datalayer didn't work
      if (!widgetData.dateBegin || !widgetData.dateEnd) {
        const arrival = $bookingDataDetails.find('.row:eq(5)').text().match(/([0-9]*)\/([0-9]*)\/([0-9]*)/);
        const departure = $bookingDataDetails.find('.row:eq(6)').text().match(/([0-9]*)\/([0-9]*)\/([0-9]*)/);
        widgetData.dateBegin = arrival && `${(`${arrival[3]}`).slice(-4)}/${(`0${arrival[1]}`).slice(-2)}/${(`0${arrival[2]}`).slice(-2)}`;
        widgetData.dateEnd = departure && `${(`${departure[3]}`).slice(-4)}/${(`0${departure[1]}`).slice(-2)}/${(`0${departure[2]}`).slice(-2)}`;
      }

      const priceText = $bookingDataPrice.find('.row > .col-6:last').text();

      if (!widgetData.price && priceText) {
        widgetData.price = thn.parseNumber(priceText);
      }
      if (!widgetData.currency && priceText) {
        widgetData.currency = thn.getCurrencyCode((priceText.match(/[^\d\s,.]+/) || [])[0]);
      }
    }

    // More fallbacks
    if (!widgetData.dateBegin || !widgetData.dateEnd) {
      widgetData.dateBegin = thn.parseUrlParameter('ARR').replace(/-/g, '/');
      widgetData.dateEnd = thn.parseUrlParameter('DEP').replace(/-/g, '/');
    }

    return widgetData;
  };

  return engine;

}

export { factory };
